import { useState } from 'react';
import { AddUpdateBrand } from './AddUpdateBrand';
import { GetBrandHistory } from './GetBrandHistory';
import { useGetBrands, useGetBrand } from '@app/sdk';
import { ContentHeader, Error, Table } from '@app/shared';
import { ComponentErrorBoundary } from '@app/utilities';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';
import { ColDef } from 'ag-grid-community';
import { useGetBrandHistory } from '../../../sdk/tms/brand/useGetBrandHistory';

export function BrandMaster() {
  const [selectedBrandId, setSelectedBrandId] = useState(undefined as any);
  const [isUpdateConfig, setIsUpdateConfig] = useState(false);
  const [isAddConfig, setIsAddConfig] = useState(false);
  const [isGetHistory, setIsGetHistory] = useState(false);

  const { isLoading, error, data: brands } = useGetBrands();
  const { data: selectedBrand } = useGetBrand({ id: selectedBrandId });
  const { data: selectedBrandHistory } = useGetBrandHistory({ id: selectedBrandId });

  const colDefs: ColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'name', headerName: 'Name' },
  ];

  const handleOnBrandSelected = (brand) => {
    setSelectedBrandId(brand.id);
    setIsAddConfig(false);
    setIsGetHistory(false);
    setIsUpdateConfig(true);
  };

  const handleAddClick = () => {
    setIsUpdateConfig(false);
    setIsGetHistory(false);
    setIsAddConfig(true);
  };

  const handleGetHistory = () => {
    setIsUpdateConfig(false);
    setIsAddConfig(false);
    setIsGetHistory(true);
  };

  const master = (
    <Segment style={{ height: '100%' }}>
      <ContentHeader>
        Brand
        <div>
          <button disabled className="ui button primary" onClick={handleAddClick}>
            Add Brand
          </button>
          <button disabled className="ui button primary" onClick={handleGetHistory}>
            Get Brand History
          </button>
        </div>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 70px)' }}>
        <Table items={brands} onSelectItem={handleOnBrandSelected} columnDefs={colDefs} />
      </div>
    </Segment>
  );

  var updateBrandDetails = (
    <Segment>
      <AddUpdateBrand key={JSON.stringify(selectedBrandId)} selectedBrand={selectedBrand} />
    </Segment>
  );
  var addBrandDetails = (
    <Segment>
      <AddUpdateBrand selectedBrand={undefined} />
    </Segment>
  );
  var getBrandHistory = (
    <Segment>
      <GetBrandHistory key={JSON.stringify(selectedBrandId)} selectedBrand={selectedBrandHistory} />
    </Segment>
  );

  const selectBrand = (
    <Segment>
      <section>Please select a brand</section>
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      {error && <Error error={error} />}
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && (
        <MasterDetailLayout
          master={master}
          detail={
            isUpdateConfig
              ? updateBrandDetails
              : isAddConfig
              ? addBrandDetails
              : selectBrand
              ? isGetHistory
                ? getBrandHistory
                : selectBrand
              : selectBrand
          }
        />
      )}
    </ComponentErrorBoundary>
  );
}
